import React from 'react';
import additional from './projectShow_color.svg'

const ProjectShow_color = ({ isMobile }) => {
  return (
    <img width={isMobile ? "36" : "56"} height={isMobile ? "36" : "56"} src={additional} />
  )
};

export default ProjectShow_color;
